export default {
  namespaced: true,
  state: {
    brandName: "",
    brandConfigs: {},
    brandCustomModuleLink: "",
    brandList: [],
    brandInfo: {},
  },
  getters: {
    brandName: (state) => state.brandName,
    brandConfigs: (state) => state.brandConfigs,
    brandCustomModuleLink: (state) => state.brandCustomModuleLink,
    brandList: (state) => state.brandList,
    brandInfo: (state) => state.brandInfo,
  },
  mutations: {
    SET_BRAND_NAME(state, value) {
      state.brandName = value;
    },
    UPDATE_BRAND_CONFIG(state, val) {
      state.brandConfigs = val;
    },
    SET_CUSTOM_MODULE_LINK(state, val) {
      state.brandCustomModuleLink = val;
    },
    SET_BRAND_LIST(state, val) {
      state.brandList = val;
    },
    SET_BRAND_INFO(state, val) {
      state.brandInfo = val;
    },
  },
  actions: {
    fetchTokenByBrand() {
      return JSON.parse(localStorage.getItem(window.brandLocalStorage))?.find(
        (o) => {
          return (
            o.brandRef ==
              new URLSearchParams(window.location.search).get("brandRef") ||
            o.brandRef == sessionStorage.getItem(window.brandSessionStorage)
          );
        }
      );
    },
    fetchBrandRef() {
      let searchParams = new URLSearchParams(window.location.search);
      let brandRef = searchParams.get("brandRef");
      let brand_ref = searchParams.get("brand_ref");
      if (brandRef || brand_ref) {
        sessionStorage.setItem(
          window.brandSessionStorage,
          brandRef || brand_ref
        );
      }
      return (
        brandRef ||
        brand_ref ||
        sessionStorage.getItem(window.brandSessionStorage)
      );
    },
    setBrandList({ commit }, dataObj) {
      commit("SET_BRAND_LIST", dataObj);
    },
    setBrandInfo({ commit }, dataObj) {
      commit("SET_BRAND_INFO", dataObj);
    },
  },
};
